import React from 'react';
import { Send, Eye, PenLine, CircleDashed } from 'lucide-react';
import { SIGNATURE_LABELS, fmtDate } from './api';
import { EtatHistorique } from '../invitation/EtatHistorique';

const ETAT_CLS = { partiel_valide: 'bg-emerald-100 text-emerald-800', acquitte: 'bg-emerald-600 text-white', impaye: 'bg-orange-100 text-orange-800', resilie: 'bg-red-600 text-white' };

const STEPS = [
  { key: 'envoye', label: 'Envoyé', Icon: Send, at: (t) => t.envoye_at, extra: (t) => (t.envoye_a ? `à ${t.envoye_a}${t.nb_envois > 1 ? ` (${t.nb_envois} envois)` : ''}` : (t.signature_en_cours ? 'signature électronique en cours' : '')) },
  { key: 'ouvert', label: 'Ouvert', Icon: Eye, at: (t) => t.ouvert_at, extra: (t) => (t.nb_ouvertures ? `${t.nb_ouvertures} consultation(s)` : '') },
  { key: 'signe', label: 'Signé', Icon: PenLine, at: (t) => t.signe_at, extra: () => '' },
];
const ORDER = ['non_envoye', 'envoye', 'ouvert', 'signe'];

export const SignatureTracking = ({ tracking, etat }) => {
  if (!tracking) return null;
  const level = ORDER.indexOf(tracking.etat);
  const badge = SIGNATURE_LABELS[tracking.etat];
  return (
    <div className="rounded-lg border border-slate-200 p-3 space-y-2" data-testid="ia-signature-tracking">
      <div className="flex items-center gap-2">
        <span className="text-xs font-semibold text-slate-700">Suivi du devis</span>
        <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${badge.cls}`} data-testid="ia-signature-etat">{badge.label}</span>
        {tracking.etat === 'signe' && (
          <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${tracking.paiement === 'paye' ? 'bg-emerald-600 text-white' : tracking.paiement === 'partiel' ? 'bg-sky-100 text-sky-800' : 'bg-slate-100 text-slate-600'}`} data-testid="ia-paiement-etat">
            {tracking.paiement === 'paye' ? 'Payé' : tracking.paiement === 'partiel' ? `Payé en partie (${tracking.paye_ttc} €)` : 'Non payé'}
          </span>
        )}
        {etat?.etat && (
          <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${ETAT_CLS[etat.etat_paiement]}`} data-testid="ia-etat-attestation">
            {etat.etat.statut_paiement} — {etat.etat.mention}
          </span>
        )}
      </div>
      <ol className="grid sm:grid-cols-3 gap-2">
        {STEPS.map(({ key, label, Icon, at, extra }, i) => {
          const done = level >= i + 1;
          return (
            <li key={key} className={`flex items-start gap-2 rounded-md p-2 ${done ? 'bg-emerald-50' : 'bg-slate-50'}`} data-testid={`ia-signature-step-${key}`}>
              {done ? <Icon className="h-4 w-4 text-emerald-600 mt-0.5" /> : <CircleDashed className="h-4 w-4 text-slate-300 mt-0.5" />}
              <div className="text-xs">
                <p className={`font-medium ${done ? 'text-emerald-800' : 'text-slate-400'}`}>{label}</p>
                {done && <p className="text-slate-500">{fmtDate(at(tracking))} {extra(tracking)}</p>}
              </div>
            </li>
          );
        })}
      </ol>
      <EtatHistorique items={etat?.etat_historique} testId="ia-etat-historique" />
    </div>
  );
};
